/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllOrganizationIPWhitelistResponseData } from './FindAllOrganizationIPWhitelistResponseData';
import {
    FindAllOrganizationIPWhitelistResponseDataFromJSON,
    FindAllOrganizationIPWhitelistResponseDataFromJSONTyped,
    FindAllOrganizationIPWhitelistResponseDataToJSON,
} from './FindAllOrganizationIPWhitelistResponseData';

/**
 * 
 * @export
 * @interface FindAllOrganizationIPWhitelistResponse
 */
export interface FindAllOrganizationIPWhitelistResponse {
    /**
     * 
     * @type {FindAllOrganizationIPWhitelistResponseData}
     * @memberof FindAllOrganizationIPWhitelistResponse
     */
    data?: FindAllOrganizationIPWhitelistResponseData;
}

/**
 * Check if a given object implements the FindAllOrganizationIPWhitelistResponse interface.
 */
export function instanceOfFindAllOrganizationIPWhitelistResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllOrganizationIPWhitelistResponseFromJSON(json: any): FindAllOrganizationIPWhitelistResponse {
    return FindAllOrganizationIPWhitelistResponseFromJSONTyped(json, false);
}

export function FindAllOrganizationIPWhitelistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllOrganizationIPWhitelistResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllOrganizationIPWhitelistResponseDataFromJSON(json['data']),
    };
}

export function FindAllOrganizationIPWhitelistResponseToJSON(value?: FindAllOrganizationIPWhitelistResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllOrganizationIPWhitelistResponseDataToJSON(value.data),
    };
}

